"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelMoveOutModal = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var copy_1 = require("../../../../copy");
var use_cancel_move_out_1 = require("../../../../data/use-cancel-move-out");
var utils_1 = require("../../../../utils");
var CancelMoveOutModal = function (_a) {
    var _b, _c, _d;
    var onCancel = _a.onCancel, isOpen = _a.isOpen, accountId = _a.accountId;
    var _e = (0, core_1.useComponents)(), SecondaryCTAButton = _e.SecondaryCTAButton, PrimaryCTAButton = _e.PrimaryCTAButton, ButtonGroup = _e.ButtonGroup, Modal = _e.Modal;
    var navigate = (0, ui_tools_1.useNavigate)();
    var moveOut = (0, core_1.useLinks)().moveOut;
    var _f = __read((0, react_1.useState)(false), 2), completed = _f[0], setCompleted = _f[1];
    var _g = __read((0, react_1.useState)(undefined), 2), error = _g[0], setError = _g[1];
    var _h = (0, use_cancel_move_out_1.useCancelMoveOut)({ accountId: accountId }), loading = _h.loading, mutate = _h.mutate;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var confirmCancel = function () {
        if (loading) {
            setError(undefined);
            return;
        }
        mutate({
            onError: function (error) { return setError(error); },
            onCompleted: function () {
                var moveOutAccount = {
                    accountId: accountId,
                    moveOutDate: '',
                    cancelled: true,
                };
                (0, utils_1.updateMoveOutAccounts)(moveOutAccount);
                setCompleted(true);
            },
        });
    };
    return (react_1.default.createElement(Modal, { "data-testid": "cancel-move-out-modal", title: error ? (react_1.default.createElement(Copy, { copyKey: "cancelFailureTitle" })) : completed ? (react_1.default.createElement(Copy, { copyKey: "cancelConfirmTitle" })) : (react_1.default.createElement(Copy, { copyKey: "cancelTitle" })), isDismissable: false, isOpen: isOpen }, error ? (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_CANCEL_ERROR, properties: (_b = {},
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b.error = error.message,
            _b) },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Copy, { copyKey: "failureModalBody" }),
            react_1.default.createElement(PrimaryCTAButton, { onClick: function () {
                    setError(undefined);
                    setCompleted(false);
                    onCancel();
                } },
                react_1.default.createElement(Copy, { copyKey: "changeDateCloseCTA" }))))) : completed ? (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_CANCEL_SUCCESS, properties: (_c = {},
            _c[core_1.INTERNAL_EVENT_FLAG] = true,
            _c) },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Copy, { copyKey: "cancelConfirmBody" }),
            react_1.default.createElement(PrimaryCTAButton, { onClick: function () {
                    navigate(moveOut(), { replace: true });
                } },
                react_1.default.createElement(Copy, { copyKey: "changeDateCloseCTA" }))))) : (react_1.default.createElement("div", null,
        react_1.default.createElement(Copy, { copyKey: "cancelBody" }),
        react_1.default.createElement(ButtonGroup, null,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.MOVE_OUT_CONFIRM_CANCEL_SUBMIT, properties: (_d = {},
                    _d[core_1.INTERNAL_EVENT_FLAG] = true,
                    _d) },
                react_1.default.createElement(PrimaryCTAButton, { onClick: function () {
                        confirmCancel();
                    } },
                    react_1.default.createElement(Copy, { copyKey: "cancelConfirm" }))),
            react_1.default.createElement(SecondaryCTAButton, { onClick: onCancel },
                react_1.default.createElement(Copy, { copyKey: "cancelBack" })))))));
};
exports.CancelMoveOutModal = CancelMoveOutModal;
